<style scoped>
.left-content {
  width: 20%;
  height: 100%;
  padding: 20px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
}
.right-content {
  flex: 1;
  overflow: hidden;
}
.el-col-5 {
  width: 33%;
  margin-bottom: 15px;
}
.el-col-4 {
  width: 33%;
}
.payment-information {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  border: 1px solid #d2d2d3;
  border-radius: 4px;
  padding: 20px;
}
.pay-item {
  display: flex;
  width: 90%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pay-name {
  width: 100px;
  line-height: 32px;
  text-align: right;
  flex-shrink: 0;
  margin-right: 10px;
}
.pay-left {
  width: 100%;
}
.pay-right {
  width: 10%;
  /* flex-shrink: 0; */
}
</style>
<template>
  <div class="content" style="display: flex">
    <div class="left-content">
      <el-table :data="tableData1" style="width: 100%" @row-click="getDetails">
        <el-table-column prop="date" label="序号" width="70"> </el-table-column>
        <el-table-column prop="name" label="医院"> </el-table-column>
      </el-table>
    </div>
    <div class="right-content">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="5"
            ><div class="search-area-div">年度：</div>
            <el-date-picker class="w70f" v-model="page.year" type="year" placeholder="选择年" :clearable="true">
            </el-date-picker
          ></el-col>
          <el-col :span="5"
            ><div class="search-area-div">月份：</div>
            <el-select class="w70f" v-model="page.month" placeholder="请选择" :clearable="true">
              <el-option v-for="item in optionsMonth" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5"
            ><div class="search-area-div">供应商：</div>
            <el-input
              class="w70f"
              v-model="page.supplierName"
              placeholder="请输入"
              type="text"
              :clearable="true"
            ></el-input
          ></el-col>
        </el-row>
        <el-row :gutter="24" class="t-right">
          <el-col :span="24">
            <div>
              <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="empty">清空</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="back-color-fff p16" style="padding: 16px">
        <el-table :data="fillReceiptData" style="width: 100%; margin-bottom: 20px" border v-loading="loading">
          <!-- <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column> -->
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="supplierName"
            label="供应商"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="year" label="年度" header-align="center" align="center" width="150"> </el-table-column>
          <el-table-column prop="month" label="月份" header-align="center" align="center" width="150">
          </el-table-column>
          <el-table-column prop="payableAmount" label="应付款" header-align="center" align="right" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.payableAmount | numDigit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="100" >
            <template slot-scope="scope">
              <a class="txt-color" @click="toDetail(scope.row)">费用详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arriveData: [{ money: '', date: '' }],
      performanceData: [],
      fillReceiptData: [],
      options: [
        {
          value: 'Y',
          label: '已付清',
        },
        {
          value: 'P',
          label: '未付清',
        },
        {
          value: 'N',
          label: '未付',
        },
      ],
      optionsMonth: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
      ],
      value: '',
      direction: 'rtl',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        medGuid: 'd2256eb2892d4887a02c6ef9a4beeffb',
        year: '',
        month: '',
        invoiceState: '',
        supplierName: '',
        paymentState: '',
      },
      tableData1: [
        {
          date: '1',
          name: '常熟市中医院',
        },
      ],
      loading: false,
    };
  },
  created() {
    // 列表
    this.getData();
  },
  watch: {
    page: {
      handler(newValue, oldValue) {
        if (newValue.year == null) {
          this.page.year = '';
        }
      },
      deep: true,
    },
  },
  methods: {
    //获取整行信息
    getDetails(row) {
      console.log(row);
    },
    //清空
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        invoiceState: '',
        medGuid: self.$store.state.medGuid,
        month: '',
        paymentState: '',
        supplierName: '',
        year: '',
      };
      self.getData();
    },
    //搜索
    searchData() {
      let self = this;
      self.getData();
    },
    //获取数据列表
    getData() {
      let self = this;
      self.loading = true;
      let invoiceState = self.page.invoiceState;
      let medGuid = self.page.medGuid;
      let pageIndex = self.page.pageIndex;
      let pageSize = self.page.pageSize;
      let supplierName = self.page.supplierName;
      let paymentState = self.page.paymentState;
      let month = self.page.month;
      let year = self.page.year && self.$moment(self.page.year).format('yyyy');
      self.api
        .get(
          `/${serverConfig.msDataBusinessService}/operating-costs/get-operating-costs-list?invoiceState=` +
            invoiceState +
            `&medGuid=` +
            medGuid +
            `&month=` +
            month +
            `&paymentState=` +
            paymentState +
            `&supplierName=` +
            supplierName +
            `&year=` +
            year +
            `&pageIndex=` +
            pageIndex +
            `&pageSize=` +
            pageSize
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.loading = false;
            self.fillReceiptData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    toDetail(row){
      let self = this;
      let query = {guid: row.supplierGuid,settleBillno:row.settleBillno, yearMonth: row.year + '-' + row.month,year:row.year,month:row.month,medName:row.medName,supplierName:row.supplierName};
      let queryData = JSON.stringify(query);
      self.$router.push({path:'/fillReceipt/expenseConfirmationDetail',query:{queryData}});
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
   
  },
  
};
</script>